import Repository from '@/repositories/Repository'
import History from '@/models/History'
import { encodeGetParams } from '@/lib/utils'

export type HistoryParams = {
  stationId: string
  range: {
    startTime: string
    endTime: string
    type: string
  }
  target: string[]
  filter?: {
    interval: number
  }
}

class HistoryRepository extends Repository {
  constructor() {
    super('/history')
  }

  async get(params: HistoryParams) {
    const query = encodeGetParams<HistoryParams>(params)
    const attributes = await super._get(query)

    return new History(attributes)
  }
}

export default HistoryRepository
